<template>
  <div class="root">
    <div class="invoice-main" ref="layout">
      <keep-alive v-if="$route.meta.keepAlive">
        <router-view></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
  </div>
</template>

<script>
import { customerRequest } from '@services'
export default {
  data: () => {
    return {
    }
  },
  mounted () {
  },
  methods: {
    async weixin () {
      let wx = require('weixin-js-sdk')
      window.wx = wx
      const data = await customerRequest.wechat.getOffiaccountSignature({ url: encodeURIComponent(window.location.href.split('#')[0]) })

      if (data.success) {
        wx.config({
          debug: false,
          appId: 'wx2e83ede6d42145ca',
          timestamp: data.result.timestamp,
          nonceStr: data.result.nonceStr,
          signature: data.result.signature,
          jsApiList: [
            'onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareQZone'
          ]
        })
        // 处理验证失败的信息
        wx.error(function (res) {
        })
        wx.ready(function (res) {
        })
      }
    }
  },
  watch: {
    $route (to, from) {
      if (to.meta.keepAlive && to.path !== from.path) {
        this.$router.go(0)
      }
    }
  }
}
</script>

<style lang="less" scoped src="./style.less"/>
